/* eslint-disable no-console */
import {
  CrownFilled,
  FileAddOutlined,
  MinusOutlined,
  PlusOutlined,
  SearchOutlined
} from '@ant-design/icons';
import {
  Button,
  // Checkbox,
  Col,
  Divider,
  Flex,
  Form,
  Input,
  Radio,
  Select,
  Table,
  TableColumnsType,
  TableProps
} from 'antd';
// import {CheckboxChangeEvent} from 'antd/es/checkbox';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import React, {useCallback, useEffect, useState} from 'react';

import {ReactComponent as FileDownloadIcon} from '../../../../../assets/icons/File_Download.svg';
import PhoneNumberInput from '../../../../../components/CustomInputs/PhoneNumberInput/PhoneNumberInput';
import {OwnerShipLabel} from '../../../../../components/Forms/Constants/IP/OwnerShipKeyLabel';
import Loader from '../../../../../components/Loader/Loader';
import {CommonErrors} from '../../../../../constants/Common';
import userGroupTypeJson from '../../../../../services/modules/JSON/getUserGroup';
import isUserDuplicate from '../../../../../services/modules/User/isUserDuplicate';
import getEmployees from '../../../../../services/modules/UserManager/getEmployeeDetails';
import getPermissionsApi from '../../../../../services/modules/UserManager/getPermissions';
import getUsersEdit from '../../../../../services/modules/UserManager/getUsersEdit';
import {sortBy} from '../../../../../shared/commonFunctions';
import {
  accessModule,
  countModule
} from '../../../../../store/companyStore/companyDetailsStore';
import useJSONStore from '../../../../../store/StaticJson/jsonStore';
import {debounce} from '../../../../../utils/debounce';
import {FirstCap} from '../../../../../utils/FormUtils/FirstCap';
import RegEx from '../../../../../utils/FormUtils/RegEx';
import showMessage from '../../../../../utils/showMessage';
import {
  hasMaxLimitReached,
  shouldBlockModuleAccess
} from '../../../../../utils/SubscriptionHelper';
import {
  filterPermissionsAndModules,
  roleFilter
} from '../Constants/commonFunctions';
import getLabelsFromSelectedPermissions from '../Constants/getLabelFromPermission';

import ModulePermissionAccordian from './ModulePermissionAccordian';
import {FormType, PostFormData} from './UserManager';

interface ValueDescription {
  value: string;
  description: string;
}

interface NestedObject {
  [key: string]: ValueDescription[] | NestedObject;
}

type PermissionsType = Record<string, NestedObject | ValueDescription[]>;

interface AddUserDrawerProps {
  currentStep?: number;
  onPostDataChange: (data: Partial<PostFormData>) => void;
  postFormData: PostFormData;
}

const AddUserDrawerForm: React.FC<AddUserDrawerProps> = ({
  currentStep,
  postFormData,
  onPostDataChange
}) => {
  // const [selectAll, setSelectAll] = useState<boolean>(false);
  const [allPermissions, setAllPermissions] = useState<PermissionsType>({});
  const [editUsers, setEditUsers] = useState<DataType[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoadingSelectTable, setIsLoadingSelectTable] =
    useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string>('');
  const accessTypes = useJSONStore.getState().accessTypes;
  const {setFieldValue} = useFormInstance();
  const [filterAccessType, setFilterAccessType] = useState(accessTypes ?? []);
  const [userGroupSelected, setUserGroupSelected] = useState('');
  const stackHolderType = useJSONStore.getState().stackHolderTypes;
  const roleTypes = useJSONStore.getState().roleTypes;
  const [shouldCallAPI, setShouldCallAPI] = useState(false);
  const userGroupTypes = useJSONStore.getState().userGroupTypes;
  const [pagination, setPagination] = useState<{
    page: number;
    pageSize: number;
    total: number;
  }>({
    page: 1,
    pageSize: 10,
    total: 10
  });
  interface DataType {
    name: string;
    email: string;
    auth0UserId: string | null;
    key: string;
  }

  const handlePermissionsChange = (permissions: string[]) => {
    onPostDataChange({permissions});
  };

  const selectedTableData = editUsers?.filter((item) =>
    postFormData.selectedAdmin ? item.key === postFormData.selectedAdmin : true
  );
  const rowSelection: TableProps<DataType>['rowSelection'] = {
    type: 'radio',
    selectedRowKeys: postFormData?.selectedAdmin
      ? [postFormData.selectedAdmin]
      : [],
    onChange: (selectedRowKeys) => {
      onPostDataChange({selectedAdmin: selectedRowKeys[0] as string});
    }
  };

  const selectedAdminRowSelection: TableProps<DataType>['rowSelection'] = {
    type: 'radio',
    selectedRowKeys: postFormData.selectedAdmin
      ? [postFormData.selectedAdmin]
      : []
  };

  const multiRowSelection: TableProps<DataType>['rowSelection'] = {
    type: 'checkbox',
    selectedRowKeys: postFormData?.users?.map((i) => {
      return i.key;
    }),
    onChange: (selectedRowKeys, record) => {
      onPostDataChange({users: record as any[]});
      // setSelectAll(selectedRowKeys.length === editUsers.length);
    }
  };

  const handleSearch = useCallback(
    debounce(() => {
      setPagination({page: 1, pageSize: 10, total: 10});
      setEditUsers([]);
      setShouldCallAPI(true);
    }),
    []
  );

  // const handleSelectAllChange = (e: CheckboxChangeEvent) => {
  //   if (e.target.checked) {
  //     onPostDataChange({users: editUsers});
  //     setSelectAll(true);
  //   } else {
  //     onPostDataChange({users: []});
  //     setSelectAll(false);
  //   }
  // };
  const handleSearchTermChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {value} = e.target;
    setSearchTerm(value.trim());
    handleSearch();
  };

  const handleInputChange = (id: number, field: string, value: string) => {
    const updatedForms = postFormData?.addMemberForms?.map((form: FormType) =>
      form.id === id ? {...form, [field]: value} : form
    );
    onPostDataChange({addMemberForms: updatedForms});
  };

  const handleAddForm = () => {
    const newForm = {
      id: Date.now(),
      firstName: '',
      lastName: '',
      emailAddress: '',
      phoneNumber: ''
    };
    if (postFormData?.addMemberForms) {
      onPostDataChange({
        addMemberForms: [...postFormData.addMemberForms, newForm]
      });
    } else {
      onPostDataChange({addMemberForms: [newForm]});
    }
  };

  const handleRemoveForm = (formId: number) => {
    const filteredForm = postFormData?.addMemberForms?.filter(
      (el: FormType) => el.id !== formId
    );
    onPostDataChange({addMemberForms: filteredForm});
    setFieldValue('addMemberForms', filteredForm);
  };

  // const filteredData = editUsers.filter(
  //   (user) =>
  //     user.email.toLowerCase().includes(searchTerm?.toLowerCase()) ||
  //     user.name.toLowerCase().includes(searchTerm?.toLowerCase())
  // );

  const columns: TableColumnsType<DataType> = [
    {
      title: 'Name',
      dataIndex: 'name'
    },
    {
      title: 'Email',
      dataIndex: 'email'
    }
  ];

  useEffect(() => {
    if (postFormData.roles) {
      const accessType = roleTypes.find((i) => {
        return i.name === postFormData.roles;
      }).accessType;
      setFilterAccessType(
        accessTypes.filter((i) => {
          return accessType?.includes(i?.name);
        })
      );
    }
  }, []);

  useEffect(() => {
    setIsLoading(true);
    Promise.all([
      postFormData.selectedStackHolder
        ? getPermissionsApi(postFormData.selectedStackHolder ?? 'Internal')
        : Promise.resolve([]),
      postFormData.selectedStackHolder === 'Internal'
        ? getEmployees({...pagination, searchParam: searchTerm})
        : postFormData.selectedStackHolder === 'External' &&
            postFormData.selectedUserGroup
          ? getUsersEdit(postFormData.selectedUserGroup, {
              ...pagination,
              searchParam: searchTerm
            })
          : Promise.resolve({users: [], total: 100}),
      postFormData.selectedStackHolder === 'External'
        ? userGroupTypeJson()
        : Promise.resolve([])
    ])
      .then(([permissions, employeesOrUsers]) => {
        setAllPermissions(permissions);
        setEditUsers((prev) => {
          return [...prev, ...(employeesOrUsers?.users ?? [])];
        });
        setPagination((prev) => {
          return {...prev, total: employeesOrUsers?.total};
        });
      })
      .catch(() => {
        setAllPermissions({});
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [postFormData.selectedStackHolder]);

  useEffect(() => {
    if (
      postFormData.selectedStackHolder === 'External' &&
      postFormData.selectedUserGroup &&
      shouldCallAPI
    ) {
      setIsLoadingSelectTable(true);
      showMessage({status: 'info', message: 'Fetching users...'});
      Promise.all([
        getUsersEdit(postFormData.selectedUserGroup, {
          ...pagination,
          searchParam: searchTerm
        })
      ])
        .then(([userData]) => {
          setEditUsers((prev) => {
            return [...prev, ...(userData?.users ?? [])];
          });
          setPagination((prev) => {
            return {...prev, total: userData?.total};
          });
        })
        .catch(() => {})
        .finally(() => {
          setShouldCallAPI(false);
          showMessage({status: 'success', message: 'Users fetched'});
          setIsLoadingSelectTable(false);
        });
    }
  }, [postFormData.selectedUserGroup, shouldCallAPI]);

  useEffect(() => {
    if (postFormData.selectedStackHolder === 'Internal' && shouldCallAPI) {
      setIsLoadingSelectTable(true);
      showMessage({status: 'info', message: 'Fetching users...'});
      Promise.all([getEmployees({...pagination, searchParam: searchTerm})])
        .then(([userData]) => {
          setEditUsers((prev) => {
            return [...prev, ...(userData?.users ?? [])];
          });
          setPagination((prev) => {
            return {...prev, total: userData?.total};
          });
        })
        .catch(() => {})
        .finally(() => {
          setShouldCallAPI(false);
          showMessage({status: 'success', message: 'Users fetched'});
          setIsLoadingSelectTable(false);
        });
    }
  }, [shouldCallAPI]);

  const shouldBlockStackHolder = (userType: string) => {
    if (
      userType === 'Internal' &&
      (hasMaxLimitReached(countModule.internalUsers) ||
        shouldBlockModuleAccess(accessModule.internalUsers))
    ) {
      return true;
    } else if (
      userType === 'External' &&
      (hasMaxLimitReached(countModule.externalStakeholders) ||
        shouldBlockModuleAccess(accessModule.externalStakeholders))
    ) {
      return true;
    }

    return false;
  };

  if (currentStep === 0)
    return (
      <>
        <Col className="gutter-row">
          <Form.Item
            name="StackholderType"
            label="Stakeholder Type"
            labelCol={{span: 24}}
            rules={[
              {
                required: true,
                message: CommonErrors.mandatory('Stakeholder Type')
              }
            ]}
          >
            <Select
              showSearch
              className="select"
              options={sortBy(stackHolderType, 'label', 'asc').map((option) => {
                return {
                  ...option,
                  label: (
                    <Flex align="center" justify="space-between">
                      <div>{option.label}</div>
                      {shouldBlockStackHolder(option.label) && (
                        <CrownFilled
                          style={{color: '#FFD700', paddingRight: 10}}
                          title="Upgrade Plan"
                        />
                      )}
                    </Flex>
                  ),
                  disabled: shouldBlockStackHolder(option.label)
                };
              })}
              placeholder="Choose Stakeholder Type"
              value={postFormData.selectedStackHolder}
              onChange={(value) => {
                onPostDataChange({
                  selectedStackHolder: value,
                  selectedUserGroup: '',
                  roles: undefined,
                  selectedAccess: null,
                  permissions: []
                });
                setFieldValue('Access', null);
                setFieldValue('userGroup', undefined);
                setFieldValue('Role', undefined);
                setEditUsers([]);
                setPagination({page: 1, pageSize: 10, total: 10});
                setSearchTerm('');
                setFieldValue('Admin Search', '');
              }}
            />
          </Form.Item>
        </Col>

        {postFormData.selectedStackHolder === 'External' && (
          <Col className="gutter-row">
            <Form.Item
              name="userGroup"
              label="User Group"
              labelCol={{span: 24}}
              rules={[
                {required: true, message: CommonErrors.mandatory('User group')}
              ]}
            >
              <Select
                allowClear
                showSearch
                className="select"
                placeholder="Choose User Group"
                value={postFormData.selectedUserGroup ?? ''}
                options={sortBy(
                  userGroupTypes.map((group) => ({
                    value: group._id,
                    label: group.name
                  })),
                  'label',
                  'asc'
                )}
                disabled={isLoading || isLoadingSelectTable}
                loading={isLoading || isLoadingSelectTable}
                onChange={(value, record: any) => {
                  onPostDataChange({
                    selectedUserGroup: value,
                    roles: undefined,
                    selectedAccess: null,
                    selectedAdmin: undefined
                  });
                  setShouldCallAPI(true);
                  setUserGroupSelected(record?.label ?? '');
                  setFieldValue('Access', null);
                  setFieldValue('Role', undefined);
                  setEditUsers([]);
                  setPagination({page: 1, pageSize: 10, total: 10});
                  setSearchTerm('');
                  setFieldValue('Admin Search', '');
                }}
                filterOption={(input, option) =>
                  option?.label.toLowerCase().includes(input.toLowerCase())
                }
              />
            </Form.Item>
          </Col>
        )}

        {postFormData.selectedStackHolder && (
          <Col className="gutter-row">
            <Form.Item
              name="Role"
              label="Role"
              labelCol={{span: 24}}
              rules={[
                {required: true, message: CommonErrors.mandatory('Role Type')}
              ]}
            >
              <Select
                allowClear
                showSearch
                className="select"
                placeholder="Choose Role"
                value={postFormData.roles ?? ''}
                disabled={
                  postFormData.selectedStackHolder === 'External'
                    ? !postFormData.selectedUserGroup
                    : false
                }
                options={sortBy(
                  roleTypes
                    .filter((role) => {
                      return postFormData.selectedStackHolder === 'External'
                        ? role.type === postFormData.selectedStackHolder &&
                            role.name.startsWith(
                              userGroupSelected?.slice(0, -1)
                            ) &&
                            !role.name.includes('Admin')
                        : role.type === postFormData.selectedStackHolder &&
                            roleFilter().includes(role.name);
                    })
                    .map((role) => ({
                      label: role.name,
                      value: role.name,
                      accessType: role.accessType
                    })),
                  'label',
                  'asc'
                )}
                onChange={(value, record: any) => {
                  onPostDataChange({
                    roles: value,
                    selectedAccess: null,
                    permissions: []
                  });
                  setFieldValue('Access', null);
                  setFilterAccessType(
                    accessTypes.filter((i) => {
                      return record?.accessType?.includes(i?.name);
                    })
                  );
                }}
                filterOption={(input, option) =>
                  option?.label.toLowerCase().includes(input.toLowerCase())
                }
              />
            </Form.Item>
          </Col>
        )}
        {postFormData.roles && (
          <Col className="gutter-row">
            <Form.Item
              name="Access"
              label="Access"
              labelCol={{span: 24}}
              rules={[
                {required: true, message: CommonErrors.mandatory('Access Type')}
              ]}
              initialValue={null}
            >
              <Radio.Group
                value={postFormData.selectedAccess ?? null}
                onChange={(e) => {
                  onPostDataChange({selectedAccess: e.target.value});
                }}
                style={{display: 'flex', justifyContent: 'start'}}
              >
                {filterAccessType.map((accessType) => {
                  return (
                    <Radio
                      key={accessType.description}
                      value={accessType.description}
                    >
                      {accessType.description}
                    </Radio>
                  );
                })}
              </Radio.Group>
            </Form.Item>
          </Col>
        )}
        {postFormData.roles && (
          <>
            {isLoading ? (
              <Loader />
            ) : (
              <Col className="gutter-row">
                <Form.Item
                  name="permissions"
                  label={
                    <span
                      style={{
                        fontSize: '16px',
                        fontWeight: 600,
                        marginTop: '10px'
                      }}
                    >
                      Choose Modules & Permissions
                    </span>
                  }
                  labelCol={{span: 24}}
                  className="permissionsUM"
                  rules={[
                    {
                      required: true,
                      validator: async () => {
                        if (
                          postFormData.permissions &&
                          postFormData.permissions.length > 0
                        ) {
                          await Promise.resolve();

                          return;
                        }

                        return await Promise.reject(
                          new Error('Please select at least one permission.')
                        );
                      }
                    }
                  ]}
                />
                <ModulePermissionAccordian
                  allPermissions={filterPermissionsAndModules(
                    allPermissions,
                    postFormData?.roles ?? ''
                  )}
                  postFormData={postFormData}
                  onPostDataChange={(data: Partial<PostFormData>) => {
                    handlePermissionsChange(data.permissions ?? []);
                  }}
                />
              </Col>
            )}
          </>
        )}
      </>
    );
  if (currentStep === 1)
    return (
      <>
        <Col className="gutter-row">
          <Form.Item name="Admin Search" labelCol={{span: 24}}>
            <Input
              style={{height: '40px'}}
              placeholder="Search by Name or Email ID"
              suffix={
                <SearchOutlined style={{fontSize: '20px', color: '#9496A1'}} />
              }
              value={searchTerm}
              onChange={handleSearchTermChange}
            />
          </Form.Item>
        </Col>

        {postFormData.selectedStackHolder === 'External' && (
          <Col>
            <Form.Item
              name="Admin Select"
              labelCol={{span: 24}}
              label="Select Admin"
              rules={[
                {
                  required: true,
                  validator: async () => {
                    if (editUsers.length > 0 && postFormData?.selectedAdmin) {
                      await Promise.resolve();

                      return;
                    }

                    return await Promise.reject(
                      new Error('Please select at least one admin.')
                    );
                  }
                }
              ]}
            >
              {postFormData.selectedAdmin ? (
                <>
                  {isLoading ? (
                    <Loader />
                  ) : (
                    <div
                      className="e1"
                      style={{
                        border: '1px solid #D2D4DA',
                        borderRadius: '12px',
                        overflow: 'hidden'
                      }}
                    >
                      <Table
                        rowKey="key"
                        dataSource={selectedTableData}
                        columns={columns}
                        pagination={false}
                        className="custom-table"
                        showHeader={false}
                        rowSelection={selectedAdminRowSelection}
                        loading={isLoading}
                      />
                    </div>
                  )}
                </>
              ) : (
                <>
                  {isLoading ? (
                    <Loader />
                  ) : (
                    <div
                      className="e2"
                      style={{
                        border: '1px solid #D2D4DA',
                        borderRadius: '12px',
                        overflow: 'hidden'
                      }}
                    >
                      <Table
                        rowKey="key"
                        rowSelection={rowSelection}
                        dataSource={editUsers}
                        columns={columns}
                        pagination={false}
                        showHeader={false}
                        scroll={{y: 500}}
                        onScroll={(e: any) => {
                          const maxScroll =
                            e.target.scrollHeight - e.target.clientHeight;
                          const currentScroll = e.target.scrollTop;
                          const {page, pageSize, total} = pagination;
                          if (currentScroll === maxScroll) {
                            if (page * pageSize < total) {
                              setShouldCallAPI(true);
                              setPagination((prev) => {
                                const {page} = prev;

                                return {...prev, page: page + 1};
                              });
                            } else {
                              showMessage({
                                status: 'info',
                                message: 'End Of List'
                              });
                            }
                          }
                        }}
                        loading={isLoadingSelectTable}
                      />
                    </div>
                  )}
                </>
              )}
            </Form.Item>
          </Col>
        )}
        {postFormData.selectedAdmin &&
          postFormData.selectedStackHolder === 'External' &&
          selectedTableData.length > 0 && (
            <>
              <Col className="gutter-row">
                <div
                  style={{
                    display: 'flex',
                    gap: '10px',
                    alignItems: 'center',
                    width: '100px'
                  }}
                >
                  <Button
                    icon={<PlusOutlined />}
                    type="primary"
                    onClick={handleAddForm}
                    disabled={
                      Array.isArray(postFormData?.addMemberForms) &&
                      postFormData.addMemberForms.length > 0
                    }
                  >
                    Add Member
                  </Button>
                  <Divider>Or</Divider>
                  <Button icon={<FileAddOutlined />} type="primary">
                    Bulk Upload
                  </Button>
                  <Button
                    icon={
                      <FileDownloadIcon
                        style={{
                          height: '25px',
                          width: '25px',
                          color: '#777986'
                        }}
                      />
                    }
                    type="primary"
                    style={{
                      border: '1px solid #777986',
                      background: 'white',
                      color: '#777986',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    Sample .CSV file
                  </Button>
                </div>
              </Col>

              <Col className="gutter-row" style={{padding: '0px !important'}}>
                <Form.Item
                  name="choose admin"
                  className="formNoShow"
                  label={
                    postFormData?.addMemberForms &&
                    postFormData?.addMemberForms?.length > 0 ? (
                      <span
                        style={{
                          fontSize: '16px',
                          fontWeight: 600,
                          marginBlock: '10px'
                        }}
                      >
                        Team Member Details
                      </span>
                    ) : (
                      ''
                    )
                  }
                  rules={[
                    {
                      required: true,
                      validator: async () => {
                        if (
                          postFormData.addMemberForms &&
                          postFormData.addMemberForms.length > 0
                        ) {
                          await Promise.resolve();

                          return;
                        }

                        return await Promise.reject(
                          new Error('Please Add at least one user.')
                        );
                      }
                    }
                  ]}
                ></Form.Item>
              </Col>
              <div>
                {postFormData?.addMemberForms?.map(
                  (form: FormType, index: number) => (
                    <div key={form.id}>
                      <div style={{display: 'flex', gap: '16px'}}>
                        <Col className="gutter-row" style={{flex: 1}}>
                          <Form.Item
                            name={['addMemberForms', index, 'firstName']}
                            label={'First Name'}
                            labelCol={{span: 10}}
                            rules={[
                              {
                                required: true,
                                message: CommonErrors.mandatory('First Name')
                              },
                              {
                                max: 100,
                                message:
                                  'First Name Should not be more than 100 Characters'
                              },
                              {
                                min: 2,
                                message:
                                  'First Name Should be more than 1 Characters'
                              },
                              {
                                pattern: RegEx.names,
                                message:
                                  'No special characters , Empty spaces or Numbers are Allowed'
                              }
                            ]}
                          >
                            <Input
                              style={{height: '40px'}}
                              placeholder="First Name"
                              value={form.firstName}
                              onInput={(e) => {
                                const target = e.target as HTMLInputElement;
                                target.value = FirstCap(target.value);
                              }}
                              onChange={(e) => {
                                handleInputChange(
                                  form.id,
                                  'firstName',
                                  e.target.value
                                );
                              }}
                            />
                          </Form.Item>
                        </Col>
                        <Col className="gutter-row" style={{flex: 1}}>
                          <Form.Item
                            name={['addMemberForms', index, 'lastName']}
                            label={'Last Name'}
                            labelCol={{span: 10}}
                            rules={[
                              {
                                required: true,
                                message: CommonErrors.mandatory('Last Name')
                              },
                              {
                                max: 100,
                                message:
                                  'Last Name Should not be more than 100 Characters'
                              },
                              {
                                min: 2,
                                message:
                                  'Last Name Should be more than 1 Characters'
                              },
                              {
                                pattern: RegEx.names,
                                message:
                                  'No special characters , Empty spaces or Numbers are Allowed'
                              }
                            ]}
                          >
                            <Input
                              style={{height: '40px'}}
                              placeholder="Last Name"
                              value={form.lastName}
                              onInput={(e) => {
                                const target = e.target as HTMLInputElement;
                                target.value = FirstCap(target.value);
                              }}
                              onChange={(e) => {
                                handleInputChange(
                                  form.id,
                                  'lastName',
                                  e.target.value
                                );
                              }}
                            />
                          </Form.Item>
                        </Col>
                      </div>
                      <Col className="gutter-row">
                        <Form.Item
                          name={['addMemberForms', index, 'emailAddress']}
                          label={'Email'}
                          labelCol={{span: 24}}
                          hasFeedback
                          validateTrigger="onBlur"
                          rules={[
                            {
                              required: true,
                              message: CommonErrors.mandatory(
                                OwnerShipLabel.EMAIL
                              )
                            },
                            {
                              min: 5,
                              message: `${OwnerShipLabel.EMAIL} Should be more than 4 Characters`
                            },
                            {
                              max: 320,
                              message: `${OwnerShipLabel.EMAIL} Should not be more than 320 Characters`
                            },
                            {
                              pattern: RegEx.email,
                              message: CommonErrors.validField(
                                OwnerShipLabel.EMAIL
                              )
                            },
                            {
                              async validator(_, value) {
                                if (value) {
                                  await isUserDuplicate({email: value}).then(
                                    async (isDuplicate) => {
                                      isDuplicate?.status
                                        ? isDuplicate?.status === 'error'
                                          ? await Promise.reject(
                                              new Error('User already exists')
                                            )
                                          : await Promise.resolve()
                                        : await Promise.reject(
                                            new Error(
                                              'Something went wrong try again later'
                                            )
                                          );
                                    }
                                  );
                                }
                              }
                            }
                          ]}
                        >
                          <Input
                            style={{height: '40px'}}
                            placeholder="Email Address"
                            value={form.emailAddress}
                            onChange={(e) => {
                              handleInputChange(
                                form.id,
                                'emailAddress',
                                e.target.value
                              );
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col className="gutter-row">
                        <Form.Item
                          name={['addMemberForms', index, 'phoneNumber']}
                          label={'Mobile Number'}
                          labelCol={{span: 24}}
                          validateTrigger="onBlur"
                          hasFeedback
                          rules={[
                            {
                              required: true,
                              message: CommonErrors.mandatory(
                                OwnerShipLabel.TELEPHONE
                              )
                            },
                            {
                              pattern: RegEx.mobile,
                              message: CommonErrors.validField(
                                OwnerShipLabel.TELEPHONE
                              )
                            },
                            {
                              async validator(_, value) {
                                if (value) {
                                  await isUserDuplicate({mobile: value}).then(
                                    async (isDuplicate) => {
                                      isDuplicate?.status
                                        ? isDuplicate?.status === 'error'
                                          ? await Promise.reject(
                                              new Error('User already exists')
                                            )
                                          : await Promise.resolve()
                                        : await Promise.reject(
                                            new Error(
                                              'Something went wrong try again later'
                                            )
                                          );
                                    }
                                  );
                                }
                              }
                            }
                          ]}
                        >
                          <PhoneNumberInput
                            name={`Phone Number ${index}`}
                            onChange={(e: any) => {
                              handleInputChange(form.id, 'phoneNumber', e);
                              // setFieldValue('')
                            }}
                          />

                          {/* <Input
                            style={{height: '40px'}}
                            placeholder="Mobile Number"
                            value={form.phoneNumber}
                            onChange={(e) => {
                              handleInputChange(
                                form.id,
                                'phoneNumber',
                                e.target.value
                              );
                            }}
                          /> */}
                        </Form.Item>
                      </Col>
                      <Flex
                        align="center"
                        // justify="space-between"
                        gap={'10px'}
                        style={{marginBottom: '20px'}}
                      >
                        {postFormData?.addMemberForms?.length &&
                          postFormData?.addMemberForms.length > 1 && (
                            <div style={{textAlign: 'start'}}>
                              <Button
                                icon={<MinusOutlined />}
                                style={{background: '#DA1E28', color: 'white'}}
                                onClick={() => {
                                  handleRemoveForm(form.id);
                                }}
                              >
                                Remove
                              </Button>
                            </div>
                          )}
                        {postFormData?.addMemberForms?.length &&
                          index ===
                            postFormData?.addMemberForms?.length - 1 && (
                            <div style={{textAlign: 'start'}}>
                              <Button
                                icon={<PlusOutlined />}
                                type="primary"
                                onClick={handleAddForm}
                              >
                                Add Member
                              </Button>
                            </div>
                          )}
                      </Flex>
                      <Divider />
                    </div>
                  )
                )}
              </div>
            </>
          )}

        {postFormData.selectedStackHolder === 'Internal' && (
          <Col>
            {/* <div style={{textAlign: 'right', marginBottom: '10px'}}>
              <Checkbox checked={selectAll} onChange={handleSelectAllChange}>
                Select All
              </Checkbox>
            </div> */}
            <Form.Item
              name="Admin Select"
              className="formNoShow"
              labelCol={{span: 24}}
              label="Select Admin/Stakeholder"
              rules={[
                {
                  required: true,
                  validator: async () => {
                    if (postFormData?.users && postFormData.users.length > 0) {
                      await Promise.resolve();

                      return;
                    }

                    return await Promise.reject(
                      new Error('Please select at least one user.')
                    );
                  }
                }
              ]}
            />
            {isLoading ? (
              <Loader />
            ) : (
              <div
                className="e3"
                style={{
                  border: '1px solid #D2D4DA',
                  borderRadius: '12px',
                  overflow: 'hidden'
                }}
              >
                <Table
                  rowKey="key"
                  rowSelection={multiRowSelection}
                  dataSource={editUsers}
                  columns={columns}
                  pagination={false}
                  className="custom-table"
                  showHeader={false}
                  loading={isLoadingSelectTable}
                  scroll={{y: 500}}
                  onScroll={(e: any) => {
                    const maxScroll =
                      e.target.scrollHeight - e.target.clientHeight;
                    const currentScroll = e.target.scrollTop;

                    const {page, pageSize, total} = pagination;

                    if (currentScroll === maxScroll) {
                      if (page * pageSize < total) {
                        setShouldCallAPI(true);
                        setPagination((prev) => {
                          const {page} = prev;

                          return {...prev, page: page + 1};
                        });
                      } else {
                        showMessage({
                          status: 'info',
                          message: 'End Of List'
                        });
                      }
                      // load more data
                    }
                  }}
                />
              </div>
            )}
          </Col>
        )}

        <Form.Item
          initialValue={getLabelsFromSelectedPermissions(
            allPermissions,
            postFormData.permissions
          )}
          name="selectedPermissions"
        ></Form.Item>
      </>
    );

  return null;
};

export default AddUserDrawerForm;
